// extracted by mini-css-extract-plugin
module.exports = {"instruction":"styles_instruction__wooTR","title":"styles_title__B9wcH","iframe":"styles_iframe__tt4VP"};